__turbopack_context__.v({
  "activeOption": "STSelect-module__8F9Scq__activeOption",
  "arrow": "STSelect-module__8F9Scq__arrow",
  "bordered": "STSelect-module__8F9Scq__bordered",
  "dark": "STSelect-module__8F9Scq__dark",
  "dropdown": "STSelect-module__8F9Scq__dropdown",
  "errorText": "STSelect-module__8F9Scq__errorText",
  "fullWidth": "STSelect-module__8F9Scq__fullWidth",
  "label": "STSelect-module__8F9Scq__label",
  "light": "STSelect-module__8F9Scq__light",
  "menu": "STSelect-module__8F9Scq__menu",
  "open": "STSelect-module__8F9Scq__open",
  "option": "STSelect-module__8F9Scq__option",
  "placeholder": "STSelect-module__8F9Scq__placeholder",
  "required": "STSelect-module__8F9Scq__required",
  "rotate": "STSelect-module__8F9Scq__rotate",
  "selectBox": "STSelect-module__8F9Scq__selectBox",
  "value": "STSelect-module__8F9Scq__value",
  "wrapper": "STSelect-module__8F9Scq__wrapper",
});
